module.exports = __webpack_public_path__ + "img/print_footprint.06239e7.webp";